export default __webpack_public_path__ + "static/media/reload.8efbee0f.svg";